import React, { FC } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import "../style.scss";
import Cricle from "../../../../assets/images/cricle.jpg";
import SelectIcon from "../../../../assets/images/select-icon.png";

interface componentProps {
    title: string;
    logo: string;
    showGiftCardHandler: any
}

const Brand: FC<componentProps> = ({ title, logo, showGiftCardHandler }) => {
    return (
        <Grid item xs={12} sm={3} md={3} lg={2}>
            {/* @ts-ignore */}
            <Box className="giftCardBox">
                <img src={logo} alt="icon" style={{ height: "160px", borderRadius: "15px", marginBottom: "10px", boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px"}} />
                <div>
                    <Typography>{title}</Typography>
                </div>
                <div className="details">
                    <div className="circle-1">
                        <img src={Cricle} alt="icon" />
                    </div>
                    <div className="dashed"></div>
                    <div className="circle-2">
                        <img src={Cricle} alt="icon" />
                    </div>
                </div>
                {/* @ts-ignore */}
                <Box display="flex" justifyContent="space-around" alignItems="center">
                    {/* @ts-ignore */}
                    <Box style={{ width: "100%" }}>
                        <Button
                            variant="contained"
                            className="w-100 text-white typeBackground round-btn"
                            size="large"
                            onClick={showGiftCardHandler}
                        >
                            انتخاب <img src={SelectIcon} alt="icon" />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Grid>
    );
};

export default Brand;
